"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetEditPage = AssetEditPage;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("@iconify/react");
var react_3 = require("react");
var react_router_dom_1 = require("react-router-dom");
var edit_classification_dialog_1 = require("../../../components/dialogs/edit-classification-dialog");
var building_1 = require("../../../features/apis/building");
var hooks_1 = require("../../../store/hooks");
var change_diff_1 = require("../../../utils/change-diff");
var to_title_case_1 = require("../../../utils/to-title-case");
var add_building_form_1 = require("./add-building-form");
var asset_field_meta_1 = require("./asset-field-meta");
var asset_summary_cards_1 = require("./asset-summary-cards");
var asset_tabs_1 = require("./asset-tabs");
function buildingSnapshot(p) {
    var _a, _b;
    return {
        name: p.name,
        code: p.code,
        type: p.type,
        description: p.description,
        isActive: p.isActive,
        address: {
            fullAddress: p.address.fullAddress,
            coordinates: { lat: ((_a = p.address.coordinates) === null || _a === void 0 ? void 0 : _a.lat) || 0, lng: ((_b = p.address.coordinates) === null || _b === void 0 ? void 0 : _b.lng) || 0 },
        },
        floors: p.floors,
        development: p.development,
        billingSettings: p.billingSettings,
        isBilledDirectlyByEskom: p.isBilledDirectlyByEskom,
        locality: p.locality,
        transmissionZone: p.transmissionZone,
        voltageLevel: p.voltageLevel,
        supplySource: p.supplySource,
        hasGridTiedGeneration: p.hasGridTiedGeneration,
        nmdKva: p.nmdKva,
        phases: p.phases,
        mainBreakerAPerPhase: p.mainBreakerAPerPhase,
        tags: p.tags,
        gla: p.gla,
        lsm: p.lsm,
        areaCodeSuffixDigits: p.areaCodeSuffixDigits,
        owner: p.owner,
        assetManagerId: p.assetManagerId,
        utilitiesManagerId: p.utilitiesManagerId,
        buildingAccountantId: p.buildingAccountantId,
        leasingManagerId: p.leasingManagerId,
        operationsManagerId: p.operationsManagerId,
        buildingManagerId: p.buildingManagerId,
    };
}
function originalSnapshot(asset) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    if (!asset)
        return null;
    return {
        name: asset.name,
        code: asset.code,
        type: asset.type,
        description: (_a = asset.description) !== null && _a !== void 0 ? _a : "",
        isActive: asset.isActive,
        address: asset.address,
        floors: asset.floors,
        development: asset.development,
        billingSettings: asset.billingSettings,
        isBilledDirectlyByEskom: (_b = asset.isBilledDirectlyByEskom) !== null && _b !== void 0 ? _b : false,
        locality: (_c = asset.locality) !== null && _c !== void 0 ? _c : "",
        transmissionZone: (_d = asset.transmissionZone) !== null && _d !== void 0 ? _d : "",
        voltageLevel: (_e = asset.voltageLevel) !== null && _e !== void 0 ? _e : "",
        supplySource: (_f = asset.supplySource) !== null && _f !== void 0 ? _f : "",
        hasGridTiedGeneration: (_g = asset.hasGridTiedGeneration) !== null && _g !== void 0 ? _g : false,
        nmdKva: asset.nmdKva,
        phases: asset.phases,
        mainBreakerAPerPhase: asset.mainBreakerAPerPhase,
        tags: (_h = asset.tags) !== null && _h !== void 0 ? _h : [],
        gla: asset.gla,
        lsm: asset.lsm,
        areaCodeSuffixDigits: (_j = asset.areaCodeSuffixDigits) !== null && _j !== void 0 ? _j : 3,
        owner: (_k = asset.owner) !== null && _k !== void 0 ? _k : null,
        assetManagerId: (_l = asset.assetManagerId) !== null && _l !== void 0 ? _l : null,
        utilitiesManagerId: (_m = asset.utilitiesManagerId) !== null && _m !== void 0 ? _m : null,
        buildingAccountantId: (_o = asset.buildingAccountantId) !== null && _o !== void 0 ? _o : null,
        leasingManagerId: (_p = asset.leasingManagerId) !== null && _p !== void 0 ? _p : null,
        operationsManagerId: (_q = asset.operationsManagerId) !== null && _q !== void 0 ? _q : null,
        buildingManagerId: (_r = asset.buildingManagerId) !== null && _r !== void 0 ? _r : null,
    };
}
function AssetEditPage() {
    var _this = this;
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;
    var assetId = (0, react_router_dom_1.useParams)().assetId;
    var searchParams = (0, react_router_dom_1.useSearchParams)()[0];
    var navigate = (0, react_router_dom_1.useNavigate)();
    var _v = (0, hooks_1.useAppSelector)(function (state) { return state.auth; }), clientId = _v.clientId, userId = _v.userId;
    var _w = (0, building_1.useFetchBuildingQuery)(assetId, { skip: !assetId }), data = _w.data, isLoading = _w.isLoading;
    var updateBuilding = (0, building_1.useUpdateBuildingMutation)()[0];
    var asset = data === null || data === void 0 ? void 0 : data.content;
    var notFound = !isLoading && !asset;
    var _x = (0, react_3.useState)("view"), mode = _x[0], setMode = _x[1];
    // SGF-1: allow deep-linking to a specific tab (e.g. ?tab=invoice-config from the Preliminary Bill gate).
    var initialTab = searchParams.get("tab") || "asset-info";
    var _y = (0, react_3.useState)(initialTab), activeTab = _y[0], setActiveTab = _y[1];
    var _z = (0, react_3.useState)(false), isSaving = _z[0], setIsSaving = _z[1];
    // Bumped on Cancel to force-remount BuildingForm and discard unsaved changes
    var _0 = (0, react_3.useState)(0), formKey = _0[0], setFormKey = _0[1];
    var _1 = (0, react_3.useState)(false), isClassificationOpen = _1[0], setIsClassificationOpen = _1[1];
    var _2 = (0, react_3.useState)([]), pendingChanges = _2[0], setPendingChanges = _2[1];
    var pendingResolverRef = (0, react_3.useRef)(null);
    var pendingPayloadRef = (0, react_3.useRef)(null);
    var formRef = (0, react_3.useRef)(null);
    var isViewMode = mode === "view";
    var isEditMode = mode === "edit";
    var isFormTab = activeTab === "asset-info" || activeTab === "asset-owner" || activeTab === "asset-settings";
    var activeSection = activeTab === "asset-info" ? "info" : activeTab === "asset-owner" ? "owner" : activeTab === "asset-settings" ? "settings" : "info";
    var buildPayload = function (data, classification) {
        var _a, _b;
        return ({
            clientId: clientId,
            _id: assetId,
            editClassification: classification.classification,
            effectiveDate: classification.effectiveDate,
            effectiveTime: classification.effectiveTime,
            reason: classification.reason,
            fieldClassifications: classification.fieldClassifications,
            lastModifiedBy: userId,
            name: data.name,
            code: data.code,
            type: data.type,
            description: data.description,
            address: {
                fullAddress: data.address.fullAddress,
                coordinates: {
                    lat: ((_a = data.address.coordinates) === null || _a === void 0 ? void 0 : _a.lat) || 0,
                    lng: ((_b = data.address.coordinates) === null || _b === void 0 ? void 0 : _b.lng) || 0,
                },
            },
            floors: data.floors,
            isActive: data.isActive,
            development: data.development,
            billingSettings: data.billingSettings,
            isBilledDirectlyByEskom: data.isBilledDirectlyByEskom,
            locality: data.locality,
            transmissionZone: data.transmissionZone,
            voltageLevel: data.voltageLevel,
            supplySource: data.supplySource,
            hasGridTiedGeneration: data.hasGridTiedGeneration,
            nmdKva: data.nmdKva,
            isPrepaid: false,
            phases: data.phases,
            mainBreakerAPerPhase: data.mainBreakerAPerPhase,
            buildingId: data.buildingId,
            tags: data.tags,
            gla: data.gla,
            lsm: data.lsm,
            areaCodeSuffixDigits: data.areaCodeSuffixDigits,
            owner: data.owner,
            assetManagerId: data.assetManagerId,
            utilitiesManagerId: data.utilitiesManagerId,
            buildingAccountantId: data.buildingAccountantId,
            leasingManagerId: data.leasingManagerId,
            operationsManagerId: data.operationsManagerId,
            buildingManagerId: data.buildingManagerId,
        });
    };
    var handleAssetUpdate = function (data) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w;
        // The form leaves nullable inputs as `null` when the user didn't touch
        // them. Merge those back with the original asset so the diff (and the BE
        // payload) treats untouched fields as unchanged instead of clobbering
        // them with null/0.
        //
        // Address is special: the form splits address into a fullAddress string
        // + a coordinates object that's only populated when the user picks an
        // autocomplete result. If the fullAddress is unchanged from the asset,
        // the coordinates state is meaningless — preserve the asset's original
        // coordinates instead of writing {lat:0,lng:0}.
        var sameAddressText = ((_b = (_a = data.address) === null || _a === void 0 ? void 0 : _a.fullAddress) !== null && _b !== void 0 ? _b : "") === ((_d = (_c = asset === null || asset === void 0 ? void 0 : asset.address) === null || _c === void 0 ? void 0 : _c.fullAddress) !== null && _d !== void 0 ? _d : "");
        var effectiveCoords = sameAddressText && ((_e = asset === null || asset === void 0 ? void 0 : asset.address) === null || _e === void 0 ? void 0 : _e.coordinates) ? asset.address.coordinates : ((_g = (_f = data.address) === null || _f === void 0 ? void 0 : _f.coordinates) !== null && _g !== void 0 ? _g : { lat: 0, lng: 0 });
        var effective = __assign(__assign({}, data), { floors: (_j = (_h = data.floors) !== null && _h !== void 0 ? _h : asset === null || asset === void 0 ? void 0 : asset.floors) !== null && _j !== void 0 ? _j : undefined, nmdKva: (_l = (_k = data.nmdKva) !== null && _k !== void 0 ? _k : asset === null || asset === void 0 ? void 0 : asset.nmdKva) !== null && _l !== void 0 ? _l : null, phases: (_o = (_m = data.phases) !== null && _m !== void 0 ? _m : asset === null || asset === void 0 ? void 0 : asset.phases) !== null && _o !== void 0 ? _o : null, mainBreakerAPerPhase: (_q = (_p = data.mainBreakerAPerPhase) !== null && _p !== void 0 ? _p : asset === null || asset === void 0 ? void 0 : asset.mainBreakerAPerPhase) !== null && _q !== void 0 ? _q : null, gla: (_s = (_r = data.gla) !== null && _r !== void 0 ? _r : asset === null || asset === void 0 ? void 0 : asset.gla) !== null && _s !== void 0 ? _s : null, lsm: (_u = (_t = data.lsm) !== null && _t !== void 0 ? _t : asset === null || asset === void 0 ? void 0 : asset.lsm) !== null && _u !== void 0 ? _u : null, address: {
                fullAddress: (_w = (_v = data.address) === null || _v === void 0 ? void 0 : _v.fullAddress) !== null && _w !== void 0 ? _w : "",
                coordinates: effectiveCoords,
            } });
        var before = originalSnapshot(asset);
        var after = buildingSnapshot(effective);
        var diff = before ? (0, change_diff_1.computeFieldDiff)(before, after, asset_field_meta_1.ASSET_FIELD_META) : [];
        if (diff.length === 0) {
            (0, react_1.addToast)({ title: "No changes", description: "Nothing to save.", color: "primary" });
            return Promise.resolve(false);
        }
        pendingPayloadRef.current = effective;
        setPendingChanges(diff);
        setIsClassificationOpen(true);
        return new Promise(function (resolve) {
            pendingResolverRef.current = resolve;
        });
    };
    var submitClassifiedUpdate = function (classification) { return __awaiter(_this, void 0, void 0, function () {
        var data, resolve, response, error_1, message;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    data = pendingPayloadRef.current;
                    resolve = pendingResolverRef.current;
                    pendingPayloadRef.current = null;
                    pendingResolverRef.current = null;
                    if (!data || !resolve)
                        return [2 /*return*/];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, updateBuilding(buildPayload(data, classification)).unwrap()];
                case 2:
                    response = _b.sent();
                    if (response.success) {
                        (0, react_1.addToast)({
                            title: "Asset Updated",
                            description: "Asset \"".concat(data.name, "\" has been updated successfully."),
                            color: "success",
                        });
                        setMode("view");
                        resolve(true);
                    }
                    else {
                        (0, react_1.addToast)({
                            title: "Update Failed",
                            description: response.message || "Could not update asset.",
                            color: "danger",
                        });
                        resolve(false);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _b.sent();
                    message = ((_a = error_1 === null || error_1 === void 0 ? void 0 : error_1.data) === null || _a === void 0 ? void 0 : _a.message) || "An error occurred while updating the asset.";
                    (0, react_1.addToast)({
                        title: "Update Failed",
                        description: message,
                        color: "danger",
                    });
                    resolve(false);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var cancelClassification = function () {
        setIsClassificationOpen(false);
        var resolve = pendingResolverRef.current;
        pendingResolverRef.current = null;
        pendingPayloadRef.current = null;
        if (resolve)
            resolve(false);
    };
    var handleSave = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!formRef.current)
                        return [2 /*return*/];
                    setIsSaving(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, formRef.current.submit()];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    setIsSaving(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleCancel = function () {
        setMode("view");
        // Discard any unsaved edits by remounting BuildingForm with fresh initialData
        setFormKey(function (k) { return k + 1; });
    };
    var handleBack = function () {
        navigate("/dashboard/assets");
    };
    if (isLoading) {
        return ((0, jsx_runtime_1.jsx)("div", { className: "flex h-full items-center justify-center", children: (0, jsx_runtime_1.jsx)(react_1.Spinner, { size: "lg" }) }));
    }
    if (notFound) {
        return ((0, jsx_runtime_1.jsxs)("div", { className: "flex h-full flex-col items-center justify-center gap-4", children: [(0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:buildings-2-linear", className: "text-6xl text-gray-400" }), (0, jsx_runtime_1.jsx)("h2", { className: "text-xl font-semibold text-gray-700", children: "Asset Not Found" }), (0, jsx_runtime_1.jsx)("p", { className: "text-gray-500", children: "The asset you're looking for doesn't exist or has been deleted." }), (0, jsx_runtime_1.jsx)(react_1.Button, { color: "primary", variant: "flat", onPress: function () { return navigate("/dashboard/assets"); }, children: "Back to Assets" })] }));
    }
    var assetFormNode = asset ? ((0, jsx_runtime_1.jsx)(add_building_form_1.BuildingForm, { ref: formRef, mode: mode, variant: "page", activeSection: activeSection, initialData: {
            _id: asset._id,
            name: asset.name,
            code: asset.code,
            type: asset.type,
            description: asset.description || "",
            address: ((_a = asset.address) === null || _a === void 0 ? void 0 : _a.fullAddress) || "",
            isActive: asset.isActive,
            developmentName: ((_b = asset.development) === null || _b === void 0 ? void 0 : _b.name) || "",
            developmentCode: ((_c = asset.development) === null || _c === void 0 ? void 0 : _c.code) || "",
            billingSettings: asset.billingSettings || { defaultBillingDate: 1, supportVariablePeriods: false },
            isBilledDirectlyByEskom: (_d = asset.isBilledDirectlyByEskom) !== null && _d !== void 0 ? _d : false,
            locality: asset.locality || "",
            transmissionZone: asset.transmissionZone || "",
            voltageLevel: asset.voltageLevel || "",
            supplySource: asset.supplySource || "",
            hasGridTiedGeneration: (_e = asset.hasGridTiedGeneration) !== null && _e !== void 0 ? _e : false,
            nmdKva: (_f = asset.nmdKva) !== null && _f !== void 0 ? _f : undefined,
            phases: (_g = asset.phases) !== null && _g !== void 0 ? _g : undefined,
            mainBreakerAPerPhase: (_h = asset.mainBreakerAPerPhase) !== null && _h !== void 0 ? _h : undefined,
            buildingId: (_j = asset.buildingId) !== null && _j !== void 0 ? _j : undefined,
            tags: asset.tags || [],
            source: asset.source,
            gla: (_k = asset.gla) !== null && _k !== void 0 ? _k : undefined,
            lsm: (_l = asset.lsm) !== null && _l !== void 0 ? _l : undefined,
            areaCodeSuffixDigits: (_m = asset.areaCodeSuffixDigits) !== null && _m !== void 0 ? _m : 3,
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            owner: (_o = asset.owner) !== null && _o !== void 0 ? _o : null,
            assetManagerId: (_p = asset.assetManagerId) !== null && _p !== void 0 ? _p : null,
            utilitiesManagerId: (_q = asset.utilitiesManagerId) !== null && _q !== void 0 ? _q : null,
            buildingAccountantId: (_r = asset.buildingAccountantId) !== null && _r !== void 0 ? _r : null,
            leasingManagerId: (_s = asset.leasingManagerId) !== null && _s !== void 0 ? _s : null,
            operationsManagerId: (_t = asset.operationsManagerId) !== null && _t !== void 0 ? _t : null,
            buildingManagerId: (_u = asset.buildingManagerId) !== null && _u !== void 0 ? _u : null,
        }, onSubmit: handleAssetUpdate, onCancel: handleCancel }, formKey)) : null;
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex h-full flex-col gap-3", children: [(0, jsx_runtime_1.jsx)("div", { className: "rounded-xl bg-white p-4 shadow-sm md:p-6", children: (0, jsx_runtime_1.jsxs)("div", { className: "flex items-center justify-between", children: [(0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-1", children: [(0, jsx_runtime_1.jsxs)(react_1.Breadcrumbs, { size: "sm", children: [(0, jsx_runtime_1.jsx)(react_1.BreadcrumbItem, { onPress: function () { return navigate("/dashboard/assets"); }, children: "Assets" }), (0, jsx_runtime_1.jsx)(react_1.BreadcrumbItem, { children: isEditMode ? "Edit Asset" : "View Asset" })] }), (0, jsx_runtime_1.jsxs)("div", { className: "flex items-center gap-3", children: [(0, jsx_runtime_1.jsx)("h1", { className: "text-xl font-bold text-gray-800", children: isEditMode ? "Edit Asset" : "View Asset" }), (0, jsx_runtime_1.jsxs)("span", { className: "text-sm text-gray-500", children: [(asset === null || asset === void 0 ? void 0 : asset.name) ? (0, to_title_case_1.toTitleCase)(asset.name) : "", " (", asset === null || asset === void 0 ? void 0 : asset.code, ")"] })] })] }), (0, jsx_runtime_1.jsxs)("div", { className: "flex items-center gap-2", children: [isViewMode && ((0, jsx_runtime_1.jsx)(react_1.Button, { variant: "flat", color: "primary", size: "sm", startContent: (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:pen-linear" }), onPress: function () {
                                        if (!isFormTab)
                                            setActiveTab("asset-info");
                                        setMode("edit");
                                    }, children: "Edit" })), isEditMode && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_1.Button, { variant: "light", size: "sm", onPress: handleCancel, children: "Cancel" }), (0, jsx_runtime_1.jsx)(react_1.Button, { color: "primary", size: "sm", isLoading: isSaving, startContent: !isSaving ? (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:diskette-linear" }) : undefined, onPress: handleSave, children: "Save Changes" })] })), (0, jsx_runtime_1.jsx)(react_1.Button, { variant: "light", size: "sm", startContent: (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:arrow-left-linear" }), onPress: handleBack, children: "Back to Assets" })] })] }) }), (0, jsx_runtime_1.jsx)(asset_summary_cards_1.AssetSummaryCards, { assetId: assetId, buildingCode: (asset === null || asset === void 0 ? void 0 : asset.code) || "" }), (0, jsx_runtime_1.jsx)(asset_tabs_1.AssetTabs, { assetId: assetId, buildingCode: (asset === null || asset === void 0 ? void 0 : asset.code) || "", activeTab: activeTab, onTabChange: setActiveTab, assetForm: assetFormNode }), (0, jsx_runtime_1.jsx)(edit_classification_dialog_1.EditClassificationDialog, { isOpen: isClassificationOpen, entityLabel: "Asset: ".concat((asset === null || asset === void 0 ? void 0 : asset.name) ? (0, to_title_case_1.toTitleCase)(asset.name) : ""), changes: pendingChanges, onCancel: cancelClassification, onConfirm: function (classification) { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                setIsClassificationOpen(false);
                                return [4 /*yield*/, submitClassifiedUpdate(classification)];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                }); } })] }));
}
